import { render, staticRenderFns } from "./toggle-switch.vue?vue&type=template&id=61a75089&"
import script from "./toggle-switch.vue?vue&type=script&lang=js&"
export * from "./toggle-switch.vue?vue&type=script&lang=js&"
import style0 from "./toggle-switch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports